import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { StationRequestV2 } from '../../../types/dashboardV2';
import { CopyIdButton } from '../../../components/common/CopyIdButton/CopyIdButton';
import { MobileStat } from '../components/MobileCardParts';

interface Props {
  request: StationRequestV2;
}

export const MobileStationRequestCard = memo(function MobileStationRequestCard({ request }: Props) {
  const { t } = useTranslation();
  const submittedBy = request.userEmail || request.userId;

  return (
    <div className="mobile-station-card" role="article">
      <div className="mobile-card-header">
        <div>
          <span className="mobile-card-id-label">
            <span className="material-symbols-outlined" style={{ fontSize: '0.875rem', marginRight: '0.25rem', verticalAlign: 'middle' }} aria-hidden="true">phone</span>
            {t('dashboard.stationRequests.table.phone')}
          </span>
          <h3 className="mobile-card-id-value">{request.phone}</h3>
        </div>
        <span className="mobile-status-badge">
          {new Date(request.createdAt).toLocaleDateString('en-GB')}
        </span>
      </div>

      <div className="mobile-card-stats mobile-card-stats-2x2">
        <MobileStat
          icon="location_city"
          label={t('dashboard.stationRequests.table.city')}
          value={request.city}
        />
        {submittedBy && (
          <div className="mobile-stat-item">
            <div className="mobile-stat-icon">
              <span className="material-symbols-outlined">person</span>
            </div>
            <div style={{ minWidth: 0 }}>
              <p className="mobile-stat-label">{t('dashboard.stationRequests.table.submittedBy')}</p>
              <p className="mobile-stat-value" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{submittedBy}</p>
            </div>
          </div>
        )}
      </div>

      {request.comment && (
        <div className="mobile-card-address" style={{ marginTop: '0.5rem' }}>
          <span className="material-symbols-outlined" aria-hidden="true">comment</span>
          <span className="mobile-card-address-text">{request.comment}</span>
        </div>
      )}

      <div className="mobile-card-footer">
        <span className="mobile-card-footer-id">
          <span className="material-symbols-outlined" aria-hidden="true">tag</span>
          <code>{request.id}</code>
        </span>
        <div className="mobile-card-actions">
          <CopyIdButton value={request.id} label={t('dashboard.stationRequests.table.copyId')} variant="icon" />
        </div>
      </div>
    </div>
  );
});

export default MobileStationRequestCard;
